import { Badge, Group, Progress, Text, Tooltip } from "@mantine/core";
import { DataTable } from "../DataTable";
import {
  TableActions,
  TableAction,
  DeleteAction,
  actionsColumn,
} from "../TableActions";
import { IconEdit } from "@tabler/icons-react";
import { useDeleteLanguage } from "../../api/languages";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";
import { openLanguageModal } from "./LanguageModal";

const getCoverageColor = (coverage) => {
  if (coverage < 70) return "red";
  if (coverage < 95) return "yellow";
  return "green";
};

const LanguagesDatatable = ({
  data,
  page,
  onPageChange,
  recordsPerPage,
  totalRecords,
  isFetching,
}) => {
  const { mutate } = useDeleteLanguage();
  const confirmDelete = useDeleteConfirm("language", mutate);

  return (
    <DataTable
      records={data}
      page={page}
      onPageChange={onPageChange}
      recordsPerPage={recordsPerPage}
      totalRecords={totalRecords}
      fetching={isFetching}
      idAccessor="code"
      borderRadius="md"
      verticalSpacing="md"
      mt="md"
      columns={[
        {
          accessor: "code",
          title: "Code",
        },
        {
          accessor: "name",
          title: "Name",
          render: (row) => (
            <Group gap="xs">
              <Text>{row.name}</Text>
              {row.isActive && (
                <Badge size="sm" color="green" variant="light">
                  Active
                </Badge>
              )}
              {row.isDefault && (
                <Badge size="sm" color="yellow" variant="light">
                  Default
                </Badge>
              )}
            </Group>
          ),
        },
        {
          accessor: "nativeName",
          title: "Native Name",
        },
        {
          accessor: "coverage",
          title: "Coverage",
          render: (language) => (
            <Tooltip label={`${language.coverage}%`}>
              <Progress.Root size={10}>
                <Progress.Section
                  value={language.coverage}
                  color={getCoverageColor(language.coverage)}
                ></Progress.Section>
              </Progress.Root>
            </Tooltip>
          ),
        },
        actionsColumn(
          (language) => (
            <TableActions>
              <TableAction
                label="Edit language"
                icon={IconEdit}
                onClick={() =>
                  openLanguageModal({
                    action: "edit",
                    languageData: language,
                  })
                }
              />
              <DeleteAction
                onDelete={() => confirmDelete({ code: language.code })}
                disabled={language.isActive}
                label={
                  language.isActive
                    ? "Can't delete active language"
                    : "Delete language"
                }
              />
            </TableActions>
          ),
          { title: "Actions" }
        ),
      ]}
    />
  );
};

export default LanguagesDatatable;
